import React from 'react';
import "./navbar.css";

import { Link } from 'react-router-dom';
import SearchIcon from '@material-ui/icons/Search';

function Navbar() {
  return (
    <div className='navbar-cotent'>
        <div className="navbar-conent2">
            {/* Logo */}
            <div className="logos">
                <h2>H&B</h2>
                <h4 className='logoname'>Group of Company</h4>
            </div>

            {/* navlinks */}
              <div className="navlinks">
                  <Link to="/" id="navbar__link1">Home</Link>
                  <Link to="/about" id="navbar__link2">About</Link>
                  <Link to="/courses" id="navbar__link3">Courses</Link>
                  <Link to="/gallery" id="navbar__link4">Gallery</Link>
                  <Link to="/franchise" id="navbar__link5">Franchise</Link>
                  <Link to="/contact" id="navbar__link6">Contact</Link>
                  <Link to="/student_result" id="navbar__link7">Student Result</Link>
              </div>

            {/* search / buttons */}
            <div className="searchbtn">
                <SearchIcon className='search' /><input type="text" id='search-input' placeholder="Search here ..." />
                <button className='navbutton'>Quick Enquery</button>
            </div>
        </div>
        
    </div>


  )
}

export default Navbar